export const storeProducts = [
  {
    id: 1,
    title: "HERE&NOW",
    img: "../images/1.jpg",
    groupImg: ["../images/1.jpg", "../images/2.jpg", "../images/3.jpg", "../images/4.jpg"],
    price: 824,
    flat: 1499,
    discount: '45%',
    info: 'Men Regular Fit Casual Shirt',
    tag: 'Men',
    category: 'shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 2,
    title: "WROGN",
    img: "../images/2.jpg",
    groupImg: ["../images/5.jpg", "../images/6.jpg", "../images/7.jpg", "../images/8.jpg"],
    price: 1259,
    flat: 2099,
    discount: '40%',
    info: 'Men Slim Fit Casual Shirt',
    tag: 'Men',
    category: 'shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 3,
    title: "HIGHLANDER",
    img: "../images/3.jpg",
    groupImg: ["../images/1.jpg", "../images/2.jpg", "../images/3.jpg", "../images/4.jpg"],
    price: 699,
    flat: 999,
    discount: '30%',
    info: 'Men Slim Fit Casual Shirt',
    tag: 'Men',
    category: 'shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 4,
    title: "Roadster",
    img: "../images/4.jpg",
    groupImg: ["../images/5.jpg", "../images/6.jpg", "../images/7.jpg", "../images/8.jpg"],
    price: 974,
    flat: 1499,
    discount: '40%',
    info: 'Washed Casual Shirt',
    tag: 'Men',
    category: 'shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 5,
    title: "DUCATI",
    img: "../images/5.jpg",
    groupImg: ["../images/1.jpg", "../images/2.jpg", "../images/3.jpg", "../images/4.jpg"],
    price: 2299,
    flat: 3999,
    discount: '20%',
    info: 'Slim Fit Casual Shirt',
    tag: 'Men',
    category: 'shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 6,
    title: "SASSAFRAS",
    img: "../images/women1.jpg",
    groupImg: ["../images/women1.jpg", "../images/women2.jpg", "../images/women3.jpg", "../images/women4.jpg"],
    price: 519,
    flat: 1299,
    discount: '60%',
    info: 'Dobby Sheer Boxy Shirt',
    tag: 'Women',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 7,
    title: "URBAN SCOTTISH",
    img: "../images/7.jpg",
    groupImg: ["../images/7.jpg", "../images/2.jpg", "../images/3.jpg", "../images/4.jpg"],
    price: 659,
    flat: 1199,
    discount: '45%',
    info: 'Boys Regular Fit Casual Shirt',
    tag: 'Boys',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 8,
    title: "Sangria",
    img: "../images/girl1.jpg",
    groupImg: ["../images/girl1.jpg", "../images/girl2.jpg", "../images/girl3.jpg", "../images/girl4.jpg"],
    price: 239,
    flat: 799,
    discount: '70%',
    info: 'Girls Printed Shirt',
    tag: 'Girls',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 9,
    title: "Docara",
    img: "../images/girl2.jpg",
    groupImg: ["../images/girl1.jpg", "../images/girl2.jpg", "../images/girl3.jpg", "../images/girl4.jpg"],
    price: 239,
    flat: 799,
    discount: '70%',
    info: 'Girls Printed Shirt',
    tag: 'Girls',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 10,
    title: "Gowser",
    img: "../images/girl3.jpg",
    groupImg: ["../images/girl1.jpg", "../images/girl2.jpg", "../images/girl3.jpg", "../images/girl4.jpg"],
    price: 239,
    flat: 799,
    discount: '70%',
    info: 'Girls Printed Shirt',
    tag: 'Girls',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 11,
    title: "Drosa",
    img: "../images/women2.jpg",
    groupImg: ["../images/women2.jpg", "../images/women3.jpg", "../images/women1.jpg", "../images/women4.jpg"],
    price: 239,
    flat: 799,
    discount: '70%',
    info: 'Girls Printed Shirt',
    tag: 'Girls',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
  {
    id: 12,
    title: "RUSIAN SCOTTISH",
    img: "../images/8.jpg",
    groupImg: ["../images/7.jpg", "../images/2.jpg", "../images/3.jpg", "../images/4.jpg"],
    price: 659,
    flat: 1199,
    discount: '45%',
    info: 'Boys Regular Fit Casual Shirt',
    tag: 'Boys',
    category: 'sleep shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
  },
];

export const detailProduct = {
    id: 1,
    title: "HERE&NOW",
    img: "../images/1.jpg",
    groupImg: ["../images/1.jpg", "../images/2.jpg", "../images/3.jpg", "../images/4.jpg"],
    price: 824,
    flat: 1499,
    discount: '45%',
    info: 'Men Regular Fit Casual Shirt',
    tag: 'Men',
    category: 'shirt',
    inBag: false,
    inWishlist: false,
    count: 0,
    total: 0
};